<template>
	<div class="expose" v-bind:class="{
		'expose--active': active
	}" @click="close">
		<div class="expose__scroller" ref="exposeScroller">
			<div class="expose__container">
				<span class="expose__close fonticon fonticon--close--filled" @click.stop="close"></span>
				<div class="expose__content" @click.stop>
					<slot />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default {
	name: 'Expose',
	components: {
	},
	data () {
		return {
		}
	},
	props: {
		active: Boolean
	},
	computed: {
	},
	watch: {
		active: function (newValue, oldValue)
		{
			var self = this;
			if(newValue === true)
			{
				self.$eventBus.$emit('expose-opened');
				document.addEventListener('keyup', self.close);
				self.$nextTick(function()
				{
					disableBodyScroll(self.$refs.exposeScroller);
				});
			}
			else
			{
				self.$eventBus.$emit('expose-closed');
				document.removeEventListener('keyup', self.close);
				enableBodyScroll(self.$refs.exposeScroller);
			}
		},
	},
	created: function()
	{
	},
	mounted: function()
	{
		var self = this;
	},
	beforeDestroy: function()
	{
		var self = this;
		document.removeEventListener('keyup', self.close);
		clearAllBodyScrollLocks();
	},
	methods: {
		close: function(evt)
		{
			var self = this;

			if(self.active)
			{
				if(evt.type !== "keyup" || (evt.type === "keyup" && evt.keyCode === 27))
				{
					self.$emit('expose-close');
				}
			}
		}
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".expose";
	#{$c}
	{
		position: fixed;
		display: block;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		color: palette(black, contrast);
		background-color: transparentize(palette(black, base, true), 0.3);
		@include extend(fade);
		@include extend(fade--out);

		&--active
		{
			@include extend(fade--in);
			z-index: 5000;
		}

		&__scroller
		{
			width: 100%;
			height: 100%;
			overflow-y: scroll;
			-webkit-overflow-scrolling: touch;
			display: flex;
			flex-wrap: nowrap;
			align-items: center;
			justify-content: center;
		}

		&__container
		{
			position: relative;
			max-width: 100%;
			padding: rem(40) $page-padding;
			margin: auto; // Stop top overflow in centered flex container
		}

		&__content
		{
			overflow: hidden;
		}

		&__close
		{
			cursor: pointer;
			color: palette(font);
			background-color: palette(white);
			border-radius: 50%;
			position: absolute;
			font-size: rem(40);
			top: rem(40);
			right: $page-padding;
			z-index: 1;
			transform: translateX(50%) translateY(-50%);
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/Expose.vue